window.osCookieControl = (function (document) {

    // ----------------
    //  config
    // ----------------

    const GTM_ID = 'GTM-PZ6HTC7';
    const COOKIE_NAME = 'CookieControl';
    const USING_HTTPS = true;
    const COOKIE_EXPIRY_IN_DAYS = 1000;

    function acceptCookies() {
        setCookie('1');
        hidePanel(true);
        loadTags();
    }

    function rejectCookies() {
        setCookie('0');
        hidePanel(true);
    }

    function loadTags() {
        // scrape from https://developers.google.com/tag-manager/quickstart
        const code = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(), event: 'gtm.js'}); var f = d.getElementsByTagName(s)[0],j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src ='https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);})(window, document, 'script', 'dataLayer', '" + GTM_ID + "');";
        const script = document.createElement('script');
        script.innerHTML = code;
        const head = document.querySelector('head');
        head.appendChild(script);
    }

    function hidePanel(doHide) {
        if (doHide) {
            panel.classList.add('hidden');
        } else {
            panel.classList.remove('hidden');
        }
    }

    function getValue() {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + COOKIE_NAME + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    function setCookie(value) {
        const date = new Date();
        date.setTime(date.getTime() + (COOKIE_EXPIRY_IN_DAYS * 24 * 60 * 60 * 1000));
        const list = [
            COOKIE_NAME + '=' + value,
            'expires=' + date.toUTCString(),
            'domain=' + panel.dataset.domain,
            'path=/',
            'samesite=lax',
        ];

        if (USING_HTTPS) list.push('secure');

        document.cookie = list.join(';');
    }

    function init() {
        const consent = getValue();

        if (consent === "0") return;

        if (consent === "1") {
            loadTags();
            return;
        }

        // no cookie: consent === undefined

        const accept = document.getElementById('cookie-consent-accept');
        accept.addEventListener('click', acceptCookies);

        const reject = document.getElementById('cookie-consent-reject');
        reject.addEventListener('click', rejectCookies);

        hidePanel(false);
    }


    const panel = document.getElementById('cookie-consent');
    init();

    // ----------------
    //  api
    // ----------------

    return {
        hidePanel,
    };

})(document);
